export const getKeysOfAppliedURLParams = (search: string) => {
  const params = new URLSearchParams(search);
  const appliedFilters: string[] = [];
  for (const element of params.keys()) {
    appliedFilters.push(element);
  }
  return appliedFilters;
};
